export function SemanticObjectSearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3054 0.99887C12.6642 0.998841 12.9554 1.29001 12.9554 1.64879L12.9555 2.94874C12.9555 3.30752 12.6644 3.59874 12.3056 3.59876L11.0056 3.59887C10.6469 3.59889 10.3557 3.30773 10.3556 2.94894L10.3555 1.649C10.3555 1.29021 10.6467 0.999 11.0054 0.998972L12.3054 0.99887Z"
        fill="#E099FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.20578 0.999846C3.56457 0.999818 3.85578 1.29098 3.8558 1.64977L3.85591 2.94972C3.85594 3.3085 3.56477 3.59971 3.20598 3.59974L1.90604 3.59984C1.54725 3.59987 1.25604 3.30871 1.25601 2.94992L1.25591 1.64997C1.25588 1.29119 1.54705 0.999977 1.90583 0.999949L3.20578 0.999846Z"
        fill="#E099FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.20676 10.0995C3.56554 10.0994 3.85675 10.3906 3.85678 10.7494L3.85688 12.0493C3.85691 12.4081 3.56575 12.6993 3.20696 12.6993L1.90701 12.6995C1.54823 12.6995 1.25702 12.4083 1.25699 12.0495L1.25689 10.7496C1.25686 10.3908 1.54802 10.0996 1.90681 10.0996L3.20676 10.0995Z"
        fill="#E099FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.07601 2.16989L3.07606 2.81986L2.42609 2.81991C2.21081 2.81993 2.03612 2.99465 2.03613 3.20993L2.03671 10.4896C2.03672 10.7049 2.21145 10.8796 2.42672 10.8796L3.0767 10.8795L3.07675 11.5295C3.07676 11.7448 3.25149 11.9195 3.46676 11.9195L5.99989 11.9193V11.1393L3.85668 11.1395L3.85665 10.7495C3.85664 10.5774 3.78799 10.412 3.6663 10.2898C3.5441 10.1682 3.37874 10.0995 3.20663 10.0996L2.81664 10.0996L2.81613 3.59985L3.20612 3.59982C3.37823 3.5998 3.54358 3.53115 3.66576 3.40947C3.78743 3.28726 3.85605 3.12191 3.85604 2.94979L3.85601 2.55981L10.3557 2.5593L10.3558 2.94928C10.3558 3.12139 10.4244 3.28674 10.5461 3.40893C10.6683 3.53059 10.8337 3.59922 11.0058 3.5992L11.3958 3.59917L11.396 6.44939L12.176 6.51438L12.1757 3.20913C12.1757 2.99385 12.001 2.81916 11.7857 2.81917L11.1357 2.81922L11.1357 2.16925C11.1357 1.95398 10.9609 1.77928 10.7457 1.7793L3.46596 1.77987C3.25069 1.77989 3.07599 1.95461 3.07601 2.16989Z"
        fill="#E099FF"
      />
      <path
        d="M7 9.5C7 10.163 7.26339 10.7989 7.73223 11.2678C8.20107 11.7366 8.83696 12 9.5 12C10.163 12 10.7989 11.7366 11.2678 11.2678C11.7366 10.7989 12 10.163 12 9.5C12 8.83696 11.7366 8.20107 11.2678 7.73223C10.7989 7.26339 10.163 7 9.5 7C8.83696 7 8.20107 7.26339 7.73223 7.73223C7.26339 8.20107 7 8.83696 7 9.5Z"
        stroke="#E099FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 11.5L13 13"
        stroke="#E099FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
